"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _requestShoppingContext = require("@ori-events/request-shopping-context");
var _shoppingContextLoaded = require("@ori-events/shopping-context-loaded");
var _userLogoutConfirmation = require("@ori-events/user-logout-confirmation");
var _userLogoutConfirmed = require("@ori-events/user-logout-confirmed");
var _userLogoutExecute = require("@ori-events/user-logout-execute");
var _userLogoutRequest = require("@ori-events/user-logout-request");
/* eslint-disable no-console -- We need to log to console */

class LogoutProvider {
  constructor(logoutCallback, context) {
    (0, _defineProperty2.default)(this, "MAX_SHOPPING_CONTEXT_AWAIT_TIME_SECONDS", 10);
    /**
     * Element on which we listen for our events and also dispatch others' events.
     */
    (0, _defineProperty2.default)(this, "context", void 0);
    /**
     * Function called after all conditions are satisfied that does the logout (on BE and in sessionStorage).
     */
    (0, _defineProperty2.default)(this, "logoutCallback", void 0);
    /**
     * Marks the phase between LogoutRequest and ShoppingBag's response to our ShoppingContext status request.
     * If the ShoppingBag fail to respond in MAX_SHOPPING_CONTEXT_AWAIT_TIME_SECONDS
     * we will no longer wait and logout user right away.
     */
    (0, _defineProperty2.default)(this, "isLogoutRequestSequenceInProgress", false);
    /**
     * Set to true on logout request event and is reset back to false
     * after short time defined by local constant MAX_SHOPPING_CONTEXT_AWAIT_TIME_SECONDS.
     */
    (0, _defineProperty2.default)(this, "isAwaitingShoppingContextInProgress", false);
    (0, _defineProperty2.default)(this, "wasLogoutShoppingContextLoadedInTime", void 0);
    this.context = context;
    this.logoutCallback = logoutCallback;
    this.bindEvents();
    console.info(`[LogoutProvider] Set up on context: `, context);
  }
  bindEvents() {
    this.context.addEventListener(_userLogoutRequest.Name, e => {
      this.onLogoutRequest(e);
    });
    this.context.addEventListener(_shoppingContextLoaded.Name, e => {
      this.onShoppingContextLoaded(e);
    });
    this.context.addEventListener(_userLogoutConfirmed.Name, e => {
      this.onLogoutConfirmed(e);
    });
    this.context.addEventListener(_userLogoutExecute.Name, e => {
      this.onLogoutExecute(e);
    });
    console.debug(`[LogoutProvider.bindEvents] Events bound.`, {
      context: this.context,
      events: [_userLogoutRequest.Name, _shoppingContextLoaded.Name, _userLogoutConfirmed.Name, _userLogoutExecute.Name]
    });
  }
  startLogoutRequestSequence() {
    if (this.isLogoutRequestSequenceInProgress) {
      return;
    }
    this.isLogoutRequestSequenceInProgress = true;
    this.wasLogoutShoppingContextLoadedInTime = undefined;

    // Limit validity of logout request to short period of time.
    this.isAwaitingShoppingContextInProgress = true;
    setTimeout(() => {
      if (typeof this.wasLogoutShoppingContextLoadedInTime === 'undefined') {
        this.wasLogoutShoppingContextLoadedInTime = false;
        this.endLogoutRequestSequence();

        // Skip to UserLogoutExecuteEvent directly and not wait for shopping bag status.
        this.context.dispatchEvent(new CustomEvent(_userLogoutExecute.Name));
      }
    }, this.MAX_SHOPPING_CONTEXT_AWAIT_TIME_SECONDS * 1000);
    console.info(`[LogoutProvider.startLogoutRequestSequence] Logout sequence started, listening for ${_shoppingContextLoaded.Name} event in next ${this.MAX_SHOPPING_CONTEXT_AWAIT_TIME_SECONDS} seconds.`);
  }
  endLogoutRequestSequence() {
    if (!this.isLogoutRequestSequenceInProgress) {
      return;
    }
    this.isLogoutRequestSequenceInProgress = false;
    if (this.isAwaitingShoppingContextInProgress) {
      this.isAwaitingShoppingContextInProgress = false;
    }
    if (this.wasLogoutShoppingContextLoadedInTime === false) {
      console.error(`[LogoutProvider.endLogoutRequestSequence] Event ${_shoppingContextLoaded.Name} failed to be fired in time (${this.MAX_SHOPPING_CONTEXT_AWAIT_TIME_SECONDS} seconds).`);
    }
  }
  onLogoutRequest(event) {
    console.debug(`[LogoutProvider.onLogoutRequest] event:`, event);
    if (this.isLogoutRequestSequenceInProgress) {
      console.info(`[LogoutProvider.onLogoutRequest] Ignoring another request - log out sequence has already been started.`);
      return;
    }
    this.startLogoutRequestSequence();
    this.context.dispatchEvent(new CustomEvent(_requestShoppingContext.Name));
  }
  onShoppingContextLoaded(event) {
    if (!this.isLogoutRequestSequenceInProgress || !this.isAwaitingShoppingContextInProgress) {
      return;
    }
    console.debug(`[LogoutProvider.onShoppingContextLoaded] event:`, event);

    // Ignore more ShoppingContextLoaded events.
    this.isAwaitingShoppingContextInProgress = false;
    this.wasLogoutShoppingContextLoadedInTime = true;
    this.endLogoutRequestSequence();
    const bagHasItems =
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- could be null
    event.detail?.shoppingBag?.shoppingBagQuantity > 0;
    if (bagHasItems) {
      this.context.dispatchEvent(new CustomEvent(_userLogoutConfirmation.Name));
    } else {
      this.context.dispatchEvent(new CustomEvent(_userLogoutExecute.Name));
    }
  }
  onLogoutConfirmed(event) {
    console.debug(`[LogoutProvider.onLogoutConfirmed] event:`, event);
    this.context.dispatchEvent(new CustomEvent(_userLogoutExecute.Name));
  }
  onLogoutExecute(event) {
    console.debug(`[LogoutProvider.onLogoutExecute] event:`, event);

    // Actually do logout = call logout callback.
    this.logoutCallback();
  }
}
exports.default = LogoutProvider;
